// Project constants
import { Capacitor } from "@capacitor/core";
import { CONSTANTS as SHARED_CONSTANTS } from "@sushicorp/utils";
import { DEFAULT_VENDORS, DEFAULT_API_URLS } from "@sushicorp/utils";
import { ArtisnPlatform, Vendor } from "artisn/types";

import { PickUpOption } from "types/common.types";

import PackageJSON from "../../package.json";

export const DOMAIN = "https://chefchoy.ec";

export const DEFAULT_PICK_UP_OPTION = {
  id: 0,
  name: "Quiero mi pedido ahora",
  forNow: true
};

export const PICK_UP_OPTIONS: PickUpOption[] = [
  DEFAULT_PICK_UP_OPTION,
  { id: 1, name: "Hora programada", forNow: false }
];

const WHATSAPP_PHONE_NUMBER = "593997914755";
export const FOOTER_PHONE_NUMBER = "024009400";

export const DEFAULT_VENDOR: Vendor = DEFAULT_VENDORS[31];

const CONSTANTS = {
  ...SHARED_CONSTANTS,
  TITLE: "CHEF CHOY",
  // Project configurations
  ARTISN: {
    ...SHARED_CONSTANTS.ARTISN,
    ACCOUNT_ID: 31,
    DEFAULT_VENDOR,
    VENDORS: [DEFAULT_VENDOR]
  },
  // REST API configurations
  API: {
    ...SHARED_CONSTANTS.API,
    MOCK_SERVICES: false,
    MOCK_WITH_INITIAL_USER_DATA: true,
    API_URL: DEFAULT_API_URLS[31]
  },
  // Activate or deactivate features
  FEATURE_FLAGS: {
    ...SHARED_CONSTANTS.FEATURE_FLAGS,
    // Allows the user to activate or deactivate the dark mode
    WITH_DARK_MODE: true,
    // Show AnonymousPasswordForm component in Checkout
    WITH_CHECKOUT_SIGNUP: false,
    // Activates the express checkout mode for payphone payments
    WITH_PAYPHONE_EXPRESS_CHECKOUT: false,
    // Show product modal
    WITH_PRODUCT_MODAL: true,
    // Show SelectAddressDropdown component in Navbar
    WITH_SELECT_ADDRESS_DROPDOWN: true,
    // Show share product
    WITH_SHARE_PRODUCT: true,
    // With delivery flow
    WITH_DELIVERY: true,
    // Show coupons
    WITH_COUPONS: true,
    // Show upsale modal
    WITH_UPSALE_MODAL: false,
    // Active the payment method express checkout
    WITH_PAYMENTEZ_EXPRESS_CHECKOUT: true,
    // Show modal merge cart
    WITH_ANONYMOUS_SHOPPING_CART_TOKEN: false,
    // Show categories menu bar
    WITH_CATEGORIES_MENU: true,
    // Package cost
    WITH_PACKAGE_COST: true,
    // Extra products as expandable
    WITH_EXTRA_PRODUCTS_AS_EXPANDABLE: false,
    // Show bottom search
    WITH_BOTTOM_SEARCH: false,
    // Show order now button
    WITH_ORDER_NOW: true,
    // Show links in footer
    WITH_FOOTER_LINKS: true,
    // Have footer links always in a new tab
    WITH_FOOTER_LINKS_NEW_TAB: true,
    // Show vertical categories list
    WITH_VERTICAL_CATEGORIES: true,
    // Show greeting text when login
    WITH_GREETING_TEXT: false,
    // Show bottom responsive buttons
    WITH_BOTTOM_RESPONSIVE_BUTTONS: false,
    // Enable users sync v1
    WITH_USER_SYNC_V1: false,
    // Enable data protection enforcement
    WITH_DATA_PROTECTION: true,
    // Enable talkshop
    WITH_TALK_SHOP: true,
    // Enable change button on shopping cart drawer
    WITH_CHANGE_BUTTON: false,
    // Enable new talkshop EP
    WITH_NEW_TALKSHOP_EP: false
  },
  STORAGE: {
    ...SHARED_CONSTANTS.STORAGE,
    AUTH_METHOD: "auth-method",
    PENDING_ORDER_TOKEN: "artisn-pending-order",
    TRANSFER_ANONYMOUS_ID: "transfer-anonymous-id",
    EXTRA_TOTAL: "extraProductsTotal",
    PAYMENTEZ_TRANSACTION_REFERENCE: "paymentez-transaction-reference",
    PRODUCTS_AMOUNT: "products-amount"
  },
  // CSS Break Points
  BREAKPOINTS: {
    mobile: 420,
    tablet: 768,
    desktop: 1024,
    wide: 1440,
    hd: 2560
  },
  // General settings
  GENERAL: {
    ...SHARED_CONSTANTS.GENERAL,
    // Platform running the application
    PLATFORM: Capacitor.getPlatform() as ArtisnPlatform,
    // Included environments that should be logged
    INCLUDED_LOGGER_ENVS: ["development", "production"],
    // App version code to enable update and support screen
    VERSION_CODE: PackageJSON.version,
    // Promotion category id
    PROMOTION_CATEGORY: process.env.NEXT_PUBLIC_PROMOTION_CATEGORY ?? "1834",
    // Product fallback image
    PRODUCT_FALLBACK_IMAGE: "/assets/images/products/fallback-img.jpeg",
    // Talkshop token
    TALKSHOP_TOKEN:
      "EAAyzw596EggBPVGvKIoESyzgOxB18wjifrsFbNDqbuXpgGjdw0uaUSxTV1SNgnKx00Dl8xSEv2BFC3Ue2TR2ZCHpuQpuGW8nZC3ZA9ZC7FHZCXgyMAqNlCL0tnFYs9MJkvj9LzOe4Is0yml57PjkanOyUauCG2EyMrvIo9oINcd4HQ4CZCcboUuZA2PYRQqnKh5jgZDZD",
    // Talkshop x api token
    TALKSHOP_X_API_TOKEN: "",
    // Talkshop identifier
    TALKSHOP_IDENTIFIER: "484146084782403"
  },
  // Date and time format strings
  DATES_FORMAT: {
    HOUR_MINUTE: "HH:mm",
    COMPLETE_DATE_TIME: "YYYY-MM-DD HH:mm:ss"
  },
  INTEGRATIONS: {
    ...SHARED_CONSTANTS.INTEGRATIONS,
    WHATSAPP: {
      PHONE_NUMBER: WHATSAPP_PHONE_NUMBER,
      RETURN_TO_APP_URL: `https://api.whatsapp.com/send/?phone=${WHATSAPP_PHONE_NUMBER}&text&app_absent=0`
    }
  }
};

export default CONSTANTS;
